export const IntroSecDetails = {
  heading1: 'WELCOME TO MY PORTFOLIO',
  typeWritterHeadings: [
    "I'm Haitham Abou Dargham",
    'Art Director & Senior Graphic Designer',
  ],
  heading2:
    'Creating impactful brand identities, creative campaigns, and digital experiences that help businesses stand out.',
  btnText: 'Download CV',
};
export const AboutSecDetails = {
  image: {
    img: 'images/about-me.jpg',
  },
  information: {
    title1: 'About Me',
    name: 'Haitham Abou Dargham',
    desc1:
      'Art Director and Senior Graphic Designer with over 10 years of experience creating impactful brand identities, marketing campaigns, and digital experiences. Passionate about transforming ideas into compelling visual stories that strengthen brands and engage audiences.',

    desc2:
      'I specialize in branding, social media design, print and digital marketing materials, presentations, and creative direction. Having worked with brands across Lebanon and the GCC, I combine creativity, strategy, and attention to detail to deliver high-quality designs that help businesses stand out and achieve their goals.',
  },
  moreAbout: [
    {
      num: '10',
      title: 'Years Experience',
    },
    {
      num: '20',
      title: 'Brands Managed',
    },
    {
      num: '200',
      title: 'Projects Delivered',
    },
  ],
};

export const ServicesDetails = {
  heading: {
    title: 'Our Services',
    text: 'How I can help take your next project to new heights! Thousands of clients have procured exceptional results while working with Me.',
  },
  details: [
    {
      name: 'Graphic Design',
      desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.',
      icon: 'fas fa-palette',
    },
    {
      name: 'Web Design',
      desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.',
      icon: 'fas fa-desktop',
    },
    {
      name: 'UI/UX Design',
      desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.',
      icon: 'fas fa-pencil-ruler',
    },
    {
      name: 'App Design & Develop',
      desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.',
      icon: 'fas fa-paint-brush',
    },
    {
      name: 'Business Analysis',
      desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.',
      icon: 'fas fa-chart-area',
    },
    {
      name: 'SEO Marketing',
      desc: 'Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry’s standard dummy text.',
      icon: 'fas fa-bullhorn',
    },
  ],
};

export const MyWorking_Skills = {
  heading: {
    title: 'Why Work With Me?',
    text: 'I combine creativity, strategy, and attention to detail to create designs that not only look exceptional but also help brands communicate effectively and achieve real business results.',
  },

  video: {
    vdo: '',
  },

  working: [
    {
      name: 'Creative Direction',
      icon: 'fas fa-lightbulb',
      desc: 'Leading creative projects from concept to execution while ensuring every design aligns with the brand vision.',
    },
    {
      name: 'Brand Identity',
      icon: 'fas fa-fingerprint',
      desc: 'Building memorable brand identities through logos, visual systems, and comprehensive brand guidelines.',
    },
    {
      name: 'Digital & Print Design',
      icon: 'fas fa-palette',
      desc: 'Designing impactful marketing materials, social media content, presentations, and print collateral.',
    },
    {
      name: 'User-Focused Design',
      icon: 'fas fa-desktop',
      desc: 'Creating intuitive website and mobile interface designs that combine aesthetics with usability.',
    },
    {
      name: 'Attention to Detail',
      icon: 'fas fa-search',
      desc: 'Delivering polished, consistent, and high-quality designs that maintain brand integrity across every touchpoint.',
    },
    {
      name: 'Collaborative Approach',
      icon: 'fas fa-users',
      desc: 'Working closely with clients, marketing teams, and stakeholders to transform ideas into successful visual solutions.',
    },
  ],

  skills: [
    {
      skill: 'Brand Identity Design',
      percent: 95,
    },
    {
      skill: 'Adobe Illustrator',
      percent: 95,
    },
    {
      skill: 'Adobe Photoshop',
      percent: 90,
    },
    {
      skill: 'Creative Direction',
      percent: 90,
    },
    {
      skill: 'Social Media Design',
      percent: 90,
    },
    {
      skill: 'Typography & Layout',
      percent: 85,
    },
    {
      skill: 'Print & Digital Design',
      percent: 90,
    },
    {
      skill: 'Adobe InDesign',
      percent: 85,
    },
  ],
};

export const CallToActionDetails = {
  heading: 'Every Great Brand Starts with Great Design',
  subHeading: 'Let us Build Something People Will Remember',
  btnText: 'Let us Talk',
};

export const WorkProcessDetails = {
  heading: {
    title: 'Work Process',
    text: 'Simple work process of build your design. Delivering work within time and budget which meets client’s requirements is our moto.',
  },
  WDetails: [
    {
      sno: 1,
      name: 'Planning & Consulting',
      desc: "We're smart, we're hard working, we're easy to talk to, and we love a challenge lisque persius mea essent possim iriure.",
    },
    {
      sno: 2,
      name: 'Content',
      desc: "We're smart, we're hard working, we're easy to talk to, and we love a challenge lisque persius mea essent possim iriure.",
    },
    {
      sno: 3,
      name: 'Conception',
      desc: "We're smart, we're hard working, we're easy to talk to, and we love a challenge lisque persius mea essent possim iriure.",
    },
    {
      sno: 4,
      name: 'Design & Development',
      desc: "We're smart, we're hard working, we're easy to talk to, and we love a challenge lisque persius mea essent possim iriure.",
    },
    {
      sno: 5,
      name: 'Final discussion',
      desc: "We're smart, we're hard working, we're easy to talk to, and we love a challenge lisque persius mea essent possim iriure.",
    },
    {
      sno: 6,
      name: 'Delivery & Launch',
      desc: "We're smart, we're hard working, we're easy to talk to, and we love a challenge lisque persius mea essent possim iriure.",
    },
  ],
};

export const OurClientsDetails = {
  heading: {
    title: 'Our Clients',
    text: "See what my happy clients say about me. I'm proud to have my clients.",
  },
  clients: [
    {
      name: 'Jay Shah',
      img: 'images/testimonial/client-sm-1.jpg',
      exp: 'Founder at Icomatic Pvt Ltd',
      summary:
        ' Easy to use, reasonably priced simply dummy text of theprinting and typesetting industry. Quidam lisque persiusinteresset his et, in quot quidam possim iriure. simply dummy text of the printing and typesetting industry.',
    },
    {
      name: 'Patric Cary',
      img: 'images/testimonial/client-sm-2.jpg',
      exp: 'Freelancer from USA',
      summary:
        ' “I am happy Working with printing and typesetting industry.Quidam lisque persius interesset his et, in quot quidampersequeris essent possim iriure. simply dummy text of theprinting and typesetting industry.”',
    },
    {
      name: 'Dennis Jacques',
      img: 'images/testimonial/client-sm-3.jpg',
      exp: 'iDeal Inc',
      summary:
        ' “Only trying it out since a few days. But up to now excellent.Seems to work flawlessly. priced simply dummy text of theprinting and typesetting industry.”',
    },
    {
      name: 'Chris Tom',
      img: 'images/testimonial/client-sm-4.jpg',
      exp: 'Company CEO from UK',
      summary:
        ' “I have used them twice now. Good rates, very efficientservice and priced simply dummy text of the printing andtypesetting industry quidam interesset his et. simply dummy text of the printing and typesetting industry. Excellent.”',
    },
  ],
  posters: [
    {
      id: 1,
      img: 'images/clients/client-logo2.png',
    },
    {
      id: 2,
      img: 'images/clients/client-logo3.png',
    },
    {
      id: 3,
      img: 'images/clients/client-logo1.png',
    },
    {
      id: 4,
      img: 'images/clients/client-logo2.png',
    },
    {
      id: 5,
      img: 'images/clients/client-logo3.png',
    },
    {
      id: 6,
      img: 'images/clients/client-logo1.png',
    },
    {
      id: 7,
      img: 'images/clients/client-logo3.png',
    },
    {
      id: 8,
      img: 'images/clients/client-logo1.png',
    },
    {
      id: 9,
      img: 'images/clients/client-logo2.png',
    },
    {
      id: 10,
      img: 'images/clients/client-logo3.png',
    },
    {
      id: 11,
      img: 'images/clients/client-logo1.png',
    },
    {
      id: 12,
      img: 'images/clients/client-logo2.png',
    },
  ],
};
export const ContactDetails = [
  {
    icon: 'fas fa-phone-alt',
    title: 'Call Me',
    p1: '+961 3 338 092',
    href: 'https://wa.me/9613338092',
  },
  {
    icon: 'fas fa-envelope',
    title: 'Email Me',
    p1: 'someonehaitham25@gmail.com',
    href: 'mailto:someonehaitham25@gmail.com?subject=Project%20Inquiry&body=I%20would%20like%20to%20discuss%20a%20project.',
  },
  {
    icon: 'fab fa-linkedin-in',
    title: 'LinkedIn',
    p1: 'Haitham Abou Dargham',
    href: 'https://www.linkedin.com/in/haitham-abou-dargham-b3a274220',
  },
];

export const socialIcons = [
  {
    title: 'Email',
    icon: 'fas fa-envelope',
    href: 'mailto:someonehaitham25@gmail.com',
    className: 'social-icons-email',
  },
  {
    title: 'Phone',
    icon: 'fas fa-phone-alt',
    href: 'tel:+9613338092',
    className: 'social-icons-phone',
  },
  {
    title: 'LinkedIn',
    icon: 'fab fa-linkedin-in',
    href: 'https://www.linkedin.com/in/haitham-abou-dargham-b3a274220',
    className: 'social-icons-linkedin',
  },
];
